// Copyright (C) 2024 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import { createAction, ActionUnion, ThunkAction, ThunkDispatch } from 'utils/redux';
import { ObjectsState } from 'reducers';

export enum ObjectsActionTypes {
    GET_OBJECT = 'GET_OBJECT',
    GET_OBJECT_SUCCESS = 'GET_OBJECT_SUCCESS',
    GET_OBJECT_FAILED = 'GET_OBJECT_FAILED',
}

const ObjectActions = {
    getObject: () => createAction(ObjectsActionTypes.GET_OBJECT),
    getObjectSuccess: (data: ObjectsState['data']) => createAction(ObjectsActionTypes.GET_OBJECT_SUCCESS, { data }),
    getObjectFailed: (error: any) => createAction(ObjectsActionTypes.GET_OBJECT_FAILED, { error }),
};

export type ObjectsActions = ActionUnion<typeof ObjectActions>;

export function getObjectAsync(id: string): ThunkAction {
    return async (dispatch: ThunkDispatch): Promise<void> => {
        dispatch(ObjectActions.getObject());

        try {
            const myHeaders = new Headers();

            myHeaders.append('accept', 'application/json, text/plain, */*');
            myHeaders.append('authorization', 'Bearer OpenObjectToken');

            const requestOptions: RequestInit = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow',
            };

            const response = await fetch(`https://aquamonitor.pttep.com/api/objects/${id}`, requestOptions);
            const result = await response.json();

            if (!response.ok) {
                throw result.message;
            }

            dispatch(ObjectActions.getObjectSuccess(result as ObjectsState['data']));
        } catch (error) {
            console.log('error ', error);
            dispatch(ObjectActions.getObjectFailed(error));
        }
    };
}
